import { Skeleton, Stack } from "@mui/material";

export default function PageSkeleton() {
  return (
    <Stack padding={2} spacing={2} justifyContent="space-between" height="100%">
      <Stack direction="row" padding={2} spacing={2}>
        <Stack>
          <Skeleton height={50} width={200} />
          <Skeleton height={50} width={200} />
          <Skeleton height={50} width={200} />
          <Skeleton height={50} width={200} />
          <Skeleton height={50} width={200} />
        </Stack>
        <Stack>
          <Skeleton height={50} width={200} />
          <Skeleton height={50} width={250} />
          <Stack marginBottom={8}></Stack>
          <Skeleton height={70} width={350} />
          <Skeleton height={70} width={350} />
          <Skeleton height={70} width={350} />
          <Skeleton height={70} width={350} />
        </Stack>
      </Stack>
      <Stack direction="row" spacing={2} justifyContent="flex-end">
        <Skeleton height={60} width={180} />
        <Skeleton height={60} width={180} />
      </Stack>
    </Stack>
  );
}
